export const OrderStatus = {
  PLACED: 'placed',
  PROCESSING: 'processing',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
};
